import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "prompt-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.getExamplePrompts(), (prompt, i) => {
      return (_openBlock(), _createElementBlock("li", {
        onClick: ($event: any) => ($setup.selectPrompt(i))
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(i + 1), 1 /* TEXT */),
        _createElementVNode("p", null, _toDisplayString(prompt[$setup.store.lang]), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_1))
    }), 256 /* UNKEYED_FRAGMENT */)),
    _createElementVNode("span", {
      class: "close-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.store.setExamplePromptsVisible(false)))
    }, "×")
  ]))
}